module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', [_c('strong', [_vm._v("Copyright")]), _vm._v(" " + _vm._s(_vm.year) + " ColonyHQ Pty Ltd.\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-link"
  }, [_c('a', {
    attrs: {
      "href": "https://colonylive.b-cdn.net/wp-content/uploads/2021/03/COLONYLive-web-Privacy-policy.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n      Privacy Policy\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-link"
  }, [_c('a', {
    attrs: {
      "href": "https://colonylive.b-cdn.net/wp-content/uploads/2021/03/Web-Copy-TandC.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n      Terms & Conditions\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cf69cdc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/app/AppFooter.vue
// module id = 3198
// module chunks = 3